<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import type { DataTableCellProps } from './templateTypes';

const props = defineProps<DataTableCellProps>();
const { t } = useI18n();

const rawValue = computed(() => props.cell.meta('rawvalue'));

const iconClass = computed(() => {
  switch (rawValue.value) {
    // Suggestion source types (ai | latest | other)
    case 'ai':
      return 'pi pi-sparkles text-purple-600';
    case 'latest':
      return 'pi pi-receipt text-blue-600';
    case 'other':
      return 'pi pi-receipt text-neutral-400';
    // Invoice item source types (actual | previous)
    case 'actual':
      return 'mdi mdi-cash-100 text-interactiongreen-600';
    case 'previous':
      return 'mdi mdi-cash-multiple text-neutral-400';
    default:
      return 'mdi mdi-help-circle text-orange-600';
  }
});

const tooltipText = computed(() => {
  switch (rawValue.value) {
    // Suggestion source types
    case 'ai':
      return t('titletags.invoiceSourceAi');
    case 'latest':
      return t('titletags.invoiceSourceLatest');
    case 'other':
      return t('titletags.invoiceSourceOther');
    // Invoice item source types
    case 'actual':
      return t('titletags.costInvoiceActual');
    case 'previous':
      return t('titletags.costInvoiceDraft');
    default:
      return t('titletags.invoiceSourceUnknown');
  }
});
</script>

<template>
  <i
    v-tooltip="{
      value: tooltipText,
      showDelay: 300,
    }"
    :class="['text-xl', iconClass]"
  ></i>
</template>
